import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as resourceActions from '../../actions/resource/resourceActions';
import SweetAlert from 'react-bootstrap-sweetalert';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

class TokenValidationModal extends React.Component {
    constructor(props) {
        super(props);
    }

    redirect() {
        window.location.href = `${LOGIN_URL}/${RELOGIN_PATH}`
    }

    render() {
        return (
            <SweetAlert
                show={this.props.showTokenValidationModal}
                title={'Token er udløbet'}
                onConfirm={this.redirect.bind(this)}
                confirmBtnCssClass="clickable"
            >
                {'Klik for at relogin'}
            </SweetAlert>
        );
    }

}

TokenValidationModal.contextTypes = {
    intl: PropTypes.object.isRequired
};


function mapStateToProps(state, ownProps) {
    return {
        showTokenValidationModal: state.showTokenValidationModal,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign(
            {},
            resourceActions
        ), dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TokenValidationModal);


// WEBPACK FOOTER //
// ./web/src/components/common/TokenValidationModal.jsx